module.exports = __webpack_public_path__ + "media/bootstrap-icons/paint-bucket-9479864e.svg";